/**
 * Load Google AdSense script when publisher ID is configured.
 * Call once at app startup – script is cached for subsequent Ad units.
 */
let scriptLoaded = false;

export function loadAdSenseScript() {
  const publisherId = process.env.REACT_APP_ADSENSE_PUBLISHER_ID;
  if (!publisherId || publisherId.trim() === '' || scriptLoaded) return;

  const script = document.createElement('script');
  script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${publisherId}`;
  script.async = true;
  script.crossOrigin = 'anonymous';
  document.head.appendChild(script);
  scriptLoaded = true;
}

/** Slot IDs from env – each must be statically referenced for CRA build */
function getSlotFromEnv(variant) {
  switch (variant) {
    case 'banner': return process.env.REACT_APP_ADSENSE_SLOT_BANNER;
    case 'game-top': return process.env.REACT_APP_ADSENSE_SLOT_GAME_TOP;
    case 'sidebar': return process.env.REACT_APP_ADSENSE_SLOT_SIDEBAR;
    case 'footer': return process.env.REACT_APP_ADSENSE_SLOT_FOOTER;
    case 'mobile-sticky': return process.env.REACT_APP_ADSENSE_SLOT_MOBILE_STICKY;
    default: return null;
  }
}

/** Get ad slot ID for a variant from env, or null if not configured */
export function getAdSlot(variant) {
  const slot = getSlotFromEnv(variant);
  return slot && String(slot).trim() !== '' ? String(slot).trim() : null;
}

export function isAdSenseConfigured() {
  const publisherId = process.env.REACT_APP_ADSENSE_PUBLISHER_ID;
  return Boolean(publisherId && publisherId.trim() !== '');
}
